import {
  AbpApplicationLocalizationService,
  ApplicationLocalizationDto,
  ApplicationLocalizationRequestDto,
} from '@abp/ng.core';
import { inject, Injectable } from '@angular/core';
import { Observable, from, map, switchMap, tap } from 'rxjs';
import { LocalConfigurationRepository } from '../local-db/repositries/local-configuration-repository';
import { LocalStorageConsts } from '../AppConsts';
import { LocalConfigurationType } from '../entities/local-configuration';
import { HealthCheckService } from '../../../app/proxy/health-checks';

@Injectable({
  providedIn: 'root',
})
export class CustomApplicationLocalizationService {
  private readonly _abpApplicationLocalizationService: AbpApplicationLocalizationService;
  private readonly _localConfigurationRepository: LocalConfigurationRepository;
  private readonly serviceProxy: HealthCheckService;

  constructor() {
    this._localConfigurationRepository = inject(LocalConfigurationRepository)
    this.serviceProxy = inject(HealthCheckService);

    this._abpApplicationLocalizationService = new AbpApplicationLocalizationService();
  }

  get: (options: ApplicationLocalizationRequestDto) => Observable<ApplicationLocalizationDto> = options => {
    const instance = this as CustomApplicationLocalizationService;
    const userFromLocalStorage = localStorage.getItem(LocalStorageConsts.CurrentUserKey);
    const user = userFromLocalStorage ? JSON.parse(userFromLocalStorage) : undefined;
    const localizationCacheUserId = `${user?.id ?? ''}:${options.cultureName}`;

    return instance.serviceProxy.checkHealth().pipe(
      switchMap(isOnline => {
        if (isOnline) {
          return instance._abpApplicationLocalizationService.get(options).pipe(
            tap(response =>
              instance._localConfigurationRepository.set(
                localizationCacheUserId,
                LocalConfigurationType.ApplicationLocalization,
                response
              )
            )
          );
        } else {
          return from(
            instance._localConfigurationRepository.get(localizationCacheUserId, LocalConfigurationType.ApplicationLocalization)
          ).pipe(map(resp => resp.data as ApplicationLocalizationDto));
        }
      })
    );
  };
}
